import { createFileRoute, redirect } from "@tanstack/react-router";
import { CarryOverClient } from "@/features/carryOver/CarryOverClient";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// Transport → Doorzetten (docs/tms-orderintake.md §3j): Hager's colli that are not in, to the next delivery day. Behind
// hager_carry_over, which admins have and the others not until it is given (HD6).
export const Route = createFileRoute("/_shell/carry-over")({
  beforeLoad: ({ context }) => {
    if (!context.session.roles.includes("admin") && !hasModule(context.session, "hager_carry_over")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: CarryOverScreen,
});

function CarryOverScreen() {
  return (
    <div className="wl-page" data-screen-label="Back-office Carry Over">
      <CarryOverClient />
    </div>
  );
}
